import colors from '@lmc/common/constants'
import { GoalStatus } from '@lmc/ts-common'
import { colours } from '@lmc/ui-kit/src/config/theme'
import { Text } from '@lmc/ui-kit/src/general'
import React from 'react'
import styled from 'styled-components'
import GoalStatusIcon from './icons/GoalStatusIcon'

const GoalProgress = ({
  percentage,
  status
}: {
  percentage: number
  status: GoalStatus
}) => {
  return status === GoalStatus.done ? (
    <GoalStatusIcon color="#EBCF6D" />
  ) : status === GoalStatus.archive ? (
    <GoalStatusIcon color={colours.neutral.color7} />
  ) : (
    <SplitTextContainer percentage={percentage}>
      <SplitText data-split={`${percentage}%`} percentage={percentage}>
        {`${percentage}%`}
      </SplitText>
    </SplitTextContainer>
  )
}

const SplitTextContainer = styled.div<{ percentage: number }>`
  height: 40px;
  width: 40px;
  margin: 0;
  background: ${({ percentage }) =>
    `linear-gradient(${colors.white} ${100 - percentage}%, ${colors.primary} ${
      100 - percentage
    }%)`};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 9px;
  border-width: 2px;
  border-color: ${colors.white};
  border-style: solid;
  box-shadow: 0 0 8px 0 #22222233;
`

const SplitText = styled.span<{ percentage: number }>`
  position: relative;
  margin: 0;
  color: ${colours.neutral.color11};
  text-transform: uppercase;
  white-space: nowrap;
  line-height: 40px;
  font-size: 12px;
  font-weight: 500;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    content: attr(data-split);
    height: ${({ percentage }) => `${100 - percentage}%`};
    color: ${colors.black};
    overflow: hidden;
    width: 100%;
    white-space: nowrap;
  }
`

export default GoalProgress
